import * as adminApi from '../../services/adminApi.js';

export const createAdminProductReportsSlice = (set, get) => ({
  productReports: {
    products: [],
    loading: false,
    error: null,
    selectedDate: '',
    filters: {
      name: '',
      branchId: '',
      category: ''
    },
    selectedProduct: null,
    detailDialogOpen: false
  },

  setProductReportFilters: (filters) =>
    set((state) => ({
      admin: {
        ...state.admin,
        productReports: {
          ...state.admin.productReports,
          filters: {
            ...state.admin.productReports.filters,
            ...filters
          }
        }
      }
    })),

  setProductReportsDate: (selectedDate) =>
    set((state) => ({
      admin: {
        ...state.admin,
        productReports: {
          ...state.admin.productReports,
          selectedDate
        }
      }
    })),

  setSelectedProductReport: (product) =>
    set((state) => ({
      admin: {
        ...state.admin,
        productReports: {
          ...state.admin.productReports,
          selectedProduct: product
        }
      }
    })),

  setProductReportDialogOpen: (isOpen) =>
    set((state) => ({
      admin: {
        ...state.admin,
        productReports: {
          ...state.admin.productReports,
          detailDialogOpen: isOpen
        }
      }
    })),

  clearProductReportErrors: () =>
    set((state) => ({
      admin: {
        ...state.admin,
        productReports: {
          ...state.admin.productReports,
          error: null
        }
      }
    })),

  loadProductReports: async (selectedDate = '', branchId = null) => {
    set((state) => ({
      admin: {
        ...state.admin,
        productReports: {
          ...state.admin.productReports,
          loading: true,
          error: null,
          selectedDate
        }
      }
    }));

    try {
      const response = await adminApi.fetchProductReports({
        dateRange: 'all',
        branchId: branchId || null,
        startDate: selectedDate || null,
        endDate: selectedDate || null
      });
      set((state) => ({
        admin: {
          ...state.admin,
          productReports: {
            ...state.admin.productReports,
            products: response.products || [],
            loading: false,
            error: null
          }
        }
      }));
    } catch (error) {
      set((state) => ({
        admin: {
          ...state.admin,
          productReports: {
            ...state.admin.productReports,
            loading: false,
            error: error.message || 'Failed to load product reports'
          }
        }
      }));
    }
  }
});
